/* lib/reports/inventoryCriteria.js — реестр 13 критериев методики анализа
 * инвентаризации (v2). id ОБЯЗАНЫ байт-в-байт совпадать с бэкендом
 * (backend/reports/inventory_calc.py CRITERIA) — это ключи criteria/flags в
 * Report.result и фильтра диагностики по кликабельным тегам. */

export const INV_CRITERIA = {
  missort:            { label: 'Пересорт',          title: 'Взаимозачёт похожих позиций (пересорт)' },
  bar:                { label: 'Бар',               title: 'Пересечение со складом бара — нужна барная ведомость' },
  staff_writeoff:     { label: 'Стаф/списания',     title: 'Стаф, проработки, бракераж — сверить с актами списаний' },
  unit_errors:        { label: 'Единицы изм.',      title: 'Ошибки единиц измерения (кг↔шт↔л)' },
  sharp_deviation:    { label: 'Резкий скачок',     title: 'Резкое отклонение к прошлому месяцу' },
  receiving_error:    { label: 'Ошибки прихода',    title: 'Выбросы количества/цены — нужен отчёт о закупках' },
  zero_fact_shortage: { label: 'Факт = 0',          title: 'Факт ноль при недостаче — вероятно, не посчитали' },
  ttk_mismatch:       { label: 'ТТК',               title: 'Несоответствие ТТК: выход/отход в системе и на практике' },
  draft_transfer:     { label: 'Переносы док-в',    title: 'Переносы из черновиков в учётную систему' },
  dynamics:           { label: 'Динамика 2 мес.',   title: 'Отклонение в одну сторону два месяца подряд' },
  datetime_issue:     { label: 'Дата/время',        title: 'Инвентаризация пересеклась с поставкой/сменой' },
  waste_pct_invalid:  { label: '% отхода',          title: 'Давно не было контрольной проработки % отхода' },
  writeoff_error:     { label: 'Ошибки списаний',   title: 'Недосписано или пересписано (стаф, порча, проработки)' },
  // машинный флаг вне 13 критериев (сигнал данных): отрицательный расчётный остаток
  negative_calc:      { label: 'Минусовой расчёт',  title: 'Отрицательный расчётный остаток — приход не проведён?' },
};

export const critLabel = (id) => (INV_CRITERIA[id] ? INV_CRITERIA[id].label : id);
export const critTitle = (id) => (INV_CRITERIA[id] ? INV_CRITERIA[id].title : id);

/* Статусы диагноза (бэкенд reports/inventory_calc.py DIAG_STATUSES). */
export const INV_DIAG_STATUS = {
  confirmed:     { tone: 'bad', label: 'подтверждено' },
  awaiting_data: { tone: 'warn', label: 'ждём данные' },
  to_recount:    { tone: 'neutral', label: 'к пересчёту' },
};

/* Тренд проблемы к прошлому месяцу (up = выросла → плохо). */
export const INV_TREND = {
  up:   { glyph: '↑', tone: 'bad', label: 'рост' },
  down: { glyph: '↓', tone: 'ok', label: 'снижение' },
  flat: { glyph: '≈', tone: 'neutral', label: 'без изменений' },
  flip: { glyph: '⇄', tone: 'warn', label: 'смена знака' },
  new:  { glyph: '∗', tone: 'neutral', label: 'новая' },
};
